import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
} from '../../../common/helpers/ReduxHelpers';

import { DOMAIN } from './Consents.constants';

export const events = {};

export const asyncEvents = makeAsyncEvents(['fetchResults', 'create', 'update', 'delete'], true);

export const types = makeActionTypes([...Object.keys(events), ...Object.keys(asyncEvents)], DOMAIN);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
    },
    types
);
